export default "__VITE_ASSET__b0549887__"